var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "v-dialog",
        {
          staticClass: "upgrade-strategy popbox",
          attrs: {
            name: "dialog2",
            title: _vm.dialogTitle,
            "close-on-click-modal": "",
            modal: true,
            width: 668,
            "append-to-body": "",
          },
          on: {
            open: _vm.showopen,
            "after-close": _vm.handleAfterClose,
            confirm: _vm.handleConfirm,
          },
          model: {
            value: _vm.isShow,
            callback: function ($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow",
          },
        },
        [
          _c(
            "v-form",
            { ref: "form", attrs: { model: _vm.ruleForm, rules: _vm.rules } },
            [
              _c(
                "v-form-item",
                { attrs: { label: "升级策略类型", prop: "strategy_type" } },
                [
                  _c("v-select", {
                    attrs: {
                      id: "set_edit_strategy_type",
                      insertContains: "set_edit_strategy_type",
                      name: "strategy_type",
                      disabled: "",
                      options: _vm.upgradeTypeOptions,
                    },
                    model: {
                      value: _vm.ruleForm.strategy_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "strategy_type", $$v)
                      },
                      expression: "ruleForm.strategy_type",
                    },
                  }),
                ],
                1
              ),
              this.ruleForm.strategy_type != "base-sn"
                ? _c(
                    "v-form-item",
                    { attrs: { label: "源版本", prop: "source_ver_id" } },
                    [
                      _c("v-select", {
                        attrs: {
                          id: "set_edit_source_version1",
                          "is-search": "",
                          insertContains: "set_edit_source_version1",
                          name: "source_ver_id",
                          options: _vm.resver,
                        },
                        model: {
                          value: _vm.ruleForm.source_ver_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "source_ver_id", $$v)
                          },
                          expression: "ruleForm.source_ver_id",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-form-item",
                { attrs: { label: "目标版本", prop: "target_ver_id" } },
                [
                  _c("v-select", {
                    attrs: {
                      id: "set_edit_target_version",
                      "is-search": "",
                      insertContains: "set_edit_target_version",
                      name: "target_ver_id",
                      options: _vm.resver,
                    },
                    model: {
                      value: _vm.ruleForm.target_ver_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "target_ver_id", $$v)
                      },
                      expression: "ruleForm.target_ver_id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-form-item",
                {
                  staticClass: "listfile",
                  attrs: {
                    label: "策略文件",
                    required: false,
                    prop: "listFile",
                  },
                },
                [
                  _c("v-upload", {
                    ref: "upload",
                    attrs: {
                      action: "/cgi-bin/upload",
                      name: "upload",
                      accept: ".txt,.bin",
                      WfileName: this.fileName,
                      "show-file-list": "",
                      "on-change": _vm.hidemsg,
                    },
                  }),
                  _vm.ruleForm.strategy_type === "base-sn"
                    ? _c("span", { staticClass: "tips" }, [
                        _vm._v("文件内容格式为: "),
                        _c("span", { staticClass: "tipsspan" }, [
                          _vm._v("SN1 "),
                          _c("div", { staticClass: "setsn1" }, [_vm._v("SN2")]),
                          _c("div", { staticClass: "setsn2" }, [_vm._v("...")]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.ruleForm.strategy_type === "base-sn"
                    ? _c(
                        "span",
                        { staticClass: "toptip" },
                        [
                          _c(
                            "v-col",
                            { attrs: { offset: 1, span: 2 } },
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: {
                                    "max-width": 210,
                                    content:
                                      "添加此策略使上传文件内的SN号与指定版本绑定，使拥有这些SN号的设备们在升级时可以升级到此指定版本",
                                    trigger: "click",
                                    position: "top-center",
                                  },
                                },
                                [
                                  _c("span", [
                                    _c("img", {
                                      attrs: {
                                        src: require("../../assets/img/tips.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.ruleForm.strategy_type === "base-mac"
                    ? _c("span", { staticClass: "tips" }, [
                        _vm._v("文件内容格式为: "),
                        _c("span", { staticClass: "tipsspan" }, [
                          _vm._v("SN1,MAC1 "),
                          _c("div", { staticClass: "setsn1" }, [
                            _vm._v("SN2,MAC2"),
                          ]),
                          _c("div", { staticClass: "setsn2" }, [_vm._v("...")]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.ruleForm.strategy_type === "base-mac"
                    ? _c(
                        "span",
                        { staticClass: "toptip" },
                        [
                          _c(
                            "v-col",
                            { attrs: { offset: 1, span: 2 } },
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: {
                                    "max-width": 210,
                                    content:
                                      "添加此策略使上传文件内的MAC和SN与当前版本和指定版本绑定，使拥有这些MAC和SN且当前软件版本号与策略的当前版本号相同的设备们在升级时可以升级到此指定版本",
                                    trigger: "click",
                                    position: "top-center",
                                  },
                                },
                                [
                                  _c("span", [
                                    _c("img", {
                                      attrs: {
                                        src: require("../../assets/img/tips.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-form-item",
                { attrs: { label: "备注", prop: "memo", required: false } },
                [
                  _c("v-input", {
                    staticClass: "remarks",
                    attrs: {
                      type: "textarea",
                      name: "memo",
                      maxlength: 200,
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.ruleForm.memo,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "memo", $$v)
                      },
                      expression: "ruleForm.memo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-loading", {
            staticClass: "loading-box",
            attrs: { visible: !_vm.upTips, name: "loading4" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }